
const selectorsCommonRU = {
  "selectors_clear": "Все",
}

const selectorsPlaceholdersRU = {
  "selectors_grower_placeholder": "Выберите поставщика",
  "selectors_car_placeholder": "Выберите машину",
  "selectors_warehouse_placeholder": "Выберите склад",
  "selectors_teudaType_placeholder": "Выберите тип документа",
  "selectors_product_placeholder": "Выберите товар",
  "selectors_size_placeholder": "Выберите размер",
  "selectors_package_placeholder": "Выберите упаковку",
  "selectors_palletType_placeholder": "Выберите паллет",
}

const selectorsEmptyRU = {
  "selectors_grower_empty": "Нет подходящих поставщиков",
  "selectors_car_empty": "Нет подходящих машин",
  "selectors_warehouse_empty": "Нет подходящих складов",
  "selectors_teudaType_empty": "Нет подходящих типов",
  "selectors_product_empty": "Нет подходящих товаров",
  "selectors_size_empty": "Нет подходящих размеров",
  "selectors_package_empty": "Нет подходящих упаковок",
  "selectors_palletType_empty": "Нет подходящих паллет",
  "selectors_location_empty": "Нет подходящих локаций",
}

export const selectorsTranslationRU = {
  selectors: {
    ...selectorsCommonRU,
    ...selectorsPlaceholdersRU,
    ...selectorsEmptyRU,
  }
}
